export const matchingFromServer = x => ({
  name: x.name,
  alias: x.alias,
  label: x.alias,
  verified: true,
})

export const matchingsToServer = matchings =>
  matchings.map(matching => ({
    domain: matching.domain,
    name: matching.name.name,
    alias: matching.name.alias,
  }))
